import { AppIcons } from "../../../data/appIcons";
import { GridColumnType } from "../../../data/gridColumnType";

export const ViewApplicationTaskListConfig = {
  columns: [
    {
      name: "Application Number",
      fieldName: "applicationNumber",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Company Name",
      fieldName: "companyName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "UEN",
      fieldName: "companyUEN",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Category (L1)",
      fieldName: "categoryL1Name",
      colType: GridColumnType.Text,
    },
    {
      name: "Sub Category (L2)",
      fieldName: "subCategoryL2Name",
      colType: GridColumnType.Text,
    },
    {
      name: "Type (L3)",
      fieldName: "typeL3Name",
      colType: GridColumnType.Text,
    },
    {
      name: "Type",
      fieldName: "type",
      colType: GridColumnType.Text,
    },
    {
      name: "Status",
      fieldName: "status",
      colType: GridColumnType.Text,
    },
    {
      name: "Assigned",
      fieldName: "assigned",
      colType: GridColumnType.Text,
    },
    // viewApplicationTaskList
    {
      name: "Submitted Date",
      fieldName: "createdAt",
      allowShort: false,
      colType: GridColumnType.DATE,
      colSettings: {
        format: 'DD MMM YYYY',
      },
    },
    {
      name: "Action",
      fieldName: "action",
      allowShort: false,
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: false,
        allowDelete: false,
      },
      customAction: [
        {
          name: "UPDATE",
          iconName: AppIcons.editIconNew,
          // iconName: AppIcons.copyIcon,
          onViewAction: (data) => {
            alert("called permissions");
          },
        },
      ],
    },
  ],
};
